export type LocalCollectionKind = "favorites" | "recent";

export const LOCAL_COLLECTIONS: Record<
  string,
  { kind: LocalCollectionKind; title: string; subtitle: string }
> = {
  favorites: { kind: "favorites", title: "Favorites", subtitle: "Games you starred" },
  recent: { kind: "recent", title: "Recently Played", subtitle: "Games you opened" },
};

export const LOCAL_COLLECTION_HREFS = Object.keys(LOCAL_COLLECTIONS).map((slug) => `/c/${slug}`);

export const isLocalCollectionHref = (href: string) => LOCAL_COLLECTION_HREFS.includes(href);
